import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';

import { BusinessSpecialtyManagerHandler } from '../../providers/business-specialty-handler';
import { BusinessSpecialtyManagerPage } from '../business-specialty-manager/business-specialty-manager';

import { Globals } from '../../providers/globals';

/**
 * Generated class for the BusinessSpecialtyListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-business-specialty-list',
  templateUrl: 'business-specialty-list.html',
})
export class BusinessSpecialtyListPage {
  	specialties: any;
	hasSpecialties: boolean = false;
	filePath: any;
	loader: any;
	isLoading: boolean = false;

	isRefreshing: boolean = false;

  	constructor(
  		public navCtrl: NavController, 
		public navParams: NavParams,
		public specialtyManagerHandler: BusinessSpecialtyManagerHandler,
		public alertCtrl: AlertController,
		public loadingCtrl: LoadingController,
		public globals: Globals,
		) {
		this.filePath = this.globals.fileUrl;
  	}

  	ionViewWillEnter() {
		this.load(null);
	}	

	doRefresh(refresher) {
		this.isRefreshing = true;

		this.load(()=>{
			this.isRefreshing = false;
		  	refresher.complete();
		})
	}  	

	createSpecialty(){
	    this.navCtrl.push(BusinessSpecialtyManagerPage, {
	      offer: {}
	    });		
	}

	manageSpecialty($e, specialty){
	    this.navCtrl.push(BusinessSpecialtyManagerPage, {
	      specialty: specialty
	    });				
	}

	load(cb){
		this.isLoading = (!this.isRefreshing) ? true : false;
		
		this.specialtyManagerHandler.getSpecialties((specialties)=>{
			this.specialties = specialties;

			this.hasSpecialties = this.specialties.length>0;

			this.isLoading = false;

			if(typeof cb == "function")
				cb()			
		})
	}

}



// WEBPACK FOOTER //
// ./src/pages/business-specialty-list/business-specialty-list.ts